import type { ContractFormValues, SectionId } from "@/features/hr/contracts/types";
import { SECTION_FIELDS } from "@/features/hr/contracts/consts";

function isFieldFilled(fieldName: keyof ContractFormValues, values: ContractFormValues): boolean {
  const value = values[fieldName];

  if (typeof value === "string") {
    return value.trim().length > 0;
  }

  if (Array.isArray(value)) {
    if (value.length === 0) return false;
    return value.every((item) => {
      if (typeof item === "string") {
        return item.trim().length > 0;
      }
      return item !== null && item !== undefined;
    });
  }

  if (typeof value === "boolean") {
    return true;
  }

  if (typeof value === "number") {
    return !isNaN(value) && value !== undefined;
  }

  return value !== undefined && value !== null;
}

function shouldCheckOptionalField(fieldName: keyof ContractFormValues, values: ContractFormValues): boolean {
  if (fieldName === "break_start_time" || fieldName === "break_end_time") {
    return values.has_break === true;
  }

  if (fieldName === "trial_duration_months") {
    return values.trial_period === true;
  }

  return true;
}

export function isSectionComplete(
  section: SectionId,
  values: ContractFormValues,
  errors: Record<string, unknown>,
): boolean {
  const sectionFields = SECTION_FIELDS[section];

  return sectionFields.every((f) => {
    if (typeof f === "string" && f.includes(".")) {
      return true;
    }
    const fieldName = f as keyof ContractFormValues;

    if (!shouldCheckOptionalField(fieldName, values)) {
      return true;
    }

    const hasError = errors[fieldName];
    if (hasError) {
      if (fieldName === "job_duties_ru" || fieldName === "job_duties_kk") {
        if (Array.isArray(hasError)) {
          if ((hasError as unknown[]).some((e) => e)) return false;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    return isFieldFilled(fieldName, values);
  });
}
